module.exports = __webpack_public_path__ + "img/logo-syg-dark.496c7197.svg";